export default __webpack_public_path__ + "static/media/RATINGS.0460ebb1.jpg";